module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.047217f6.ttf";